import React, {PropTypes, Component} from 'react';
import {classSet} from 'rc-util';

function calcPoints(marks, dots, step, min, max) {
  const points = Object.keys(marks).map(parseFloat);
  if (dots) {
    for (let i = min; i <= max; i = i + step) {
      points.push(i);
    }
  }
  return points;
}

class Dots extends Component {
  render() {
    const {prefixCls, marks, dots, step, included, lowerBound, upperBound, max, min} = this.props;
    const range = max - min;
    const elements = calcPoints(marks, dots, step, min, max).map((point) => {
      const offset = (point - min) / range * 100 + '%';
      const style = {left: offset};

      const isActived = (!included && point === upperBound) ||
              (included && point <= upperBound && point >= lowerBound);
      const pointClassName = classSet({
        [prefixCls + '-dot']: true,
        [prefixCls + '-dot-active']: isActived,
      });

      return <span className={pointClassName} style={style} key={point} />;
    });

    return <div className={prefixCls + '-step'}>{elements}</div>;
  }
}

// const Dots = ({prefixCls, marks, dots, step, included, lowerBound, upperBound, max, min}) => {
//   const range = max - min;
//   const elements = calcPoints(marks, dots, step, min, max).map((point) => {
//     const offset = (point - min) / range * 100 + '%';
//     const style = { left: offset };
//
//     const isActived = (!included && point === upperBound) ||
//             (included && point <= upperBound && point >= lowerBound);
//     const pointClassName = classSet({
//       [prefixCls + '-dot']: true,
//       [prefixCls + '-dot-active']: isActived,
//     });
//
//     return <span className={pointClassName} style={style} key={point} />;
//   });
//
//   return <div className={prefixCls + '-step'}>{elements}</div>;
// };

Dots.propTypes = {
  prefixCls: PropTypes.string.isRequired,
  marks: PropTypes.object.isRequired,
  dots: PropTypes.bool.isRequired,
  step: PropTypes.number.isRequired,
  included: PropTypes.bool.isRequired,
  lowerBound: PropTypes.number.isRequired,
  upperBound: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired
};

export default Dots;
